/* eslint-disable */
import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import Loader from './Loader';
import metadata from '../../../../metadata.min.json';
import Icon, { GLYPHS } from '../../../components/Icon';
import { getCountryCodeByCountryAndCurrency } from '../../../utils/intl';

// eslint-disable-next-line react/prop-types
const PhoneInputComponent = ({ send, changePhoneNumber, isFetching, smsStatus, shop }) => (
  <div className="c-nots-phone">
    {isFetching && <Loader />}
    {smsStatus === 'error' && (
      <p className="u-text-small u-co-error">
        Oops! You're not mobile. Txt link instead.
      </p>
    )}
    {smsStatus === 'success' && (
      <p className="u-text-small u-co-success">
        The link was sent successfully!
      </p>
    )}
    {!isFetching && smsStatus === '' && (
      <div style={{ width: '32px', height: '4px', marginBottom: '10px', marginTop: '32px' }} />
    )}
    <div className="c-nots-phone_input-wrapper">
      <PhoneInput
        className="c-nots-phone_input"
        metadata={metadata}
        international={false}
        country={getCountryCodeByCountryAndCurrency(shop) || 'US'}
        countryOptions={['US', 'CA', 'GB', '...']}
        onChange={changePhoneNumber}
        flagsPath="https://flagicons.lipis.dev/flags/4x3/"
      />
      <button className="c-nots-phone_submit-btn" onClick={send}>
        <Icon glyph={GLYPHS.SEND_ARROW} />
      </button>
    </div>
  </div>
);

export default PhoneInputComponent;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/components/PhoneInputComponent.jsx